import React from 'react';
import {
	CategoryInsightLabel,
	CategoryInsightValue,
	CategoryInsightRow,
	AbortPopup,
	ModalBody,
} from '../../../../../CategoryManagement/Insights/InsightsSettings/InsightsSettings.styles';
import ToggleSidebar from 'CategoryManagement/Components/ToggleSidebar/ToggleSidebar';
import {
	ApButtonSecondary,
	ApInput,
	ApLoaderDefault,
	ApLoaderText,
} from '@alixpartners/ui-components';
import Modal from 'components/Modal';
import { useSavingCalculationContext } from '../Contexts/SavingCalculationProvider';
import { SettingsContainer, SettingsHighDiv } from './SavingCalculation.styles';

function SavingCalculationSettings(props) {
	const {
		savingsCalculationSettings,
		setSavingsCalculationSettings,
		saveSavingCalculationFilters,
		isSaving,
	} = useSavingCalculationContext();
	const { closeSettings, setCloseSettings } = props;

	const renderSavingBlock = () => {
		return (
			<>
				{isSaving && (
					<AbortPopup>
						<Modal width="550px" zIndex="10000000">
							<ModalBody>
								Saving settings, please wait.<br />
								<ApLoaderDefault loaderText={() => <ApLoaderText />} />
							</ModalBody>
						</Modal>
					</AbortPopup>
				)}
			</>
		);
	};

	// const validateSettingValues = () => {
	// 	let disableBtn = false;
	// 	for (let item in savingsCalculationSettings) {
	// 		if (!savingsCalculationSettings[item]) {
	// 			disableBtn = true;
	// 		}
	// 	}
	// 	if (
	// 		savingsCalculationSettings.DelayLow >=
	// 		savingsCalculationSettings.DelayHigh
	// 	) {
	// 		disableBtn = true;
	// 	} else if (
	// 		savingsCalculationSettings.EarlyLow >=
	// 		savingsCalculationSettings.EarlyHigh
	// 	) {
	// 		disableBtn = true;
	// 	} else if (
	// 		savingsCalculationSettings.WCLow >= savingsCalculationSettings.WCHigh
	// 	) {
	// 		disableBtn = true;
	// 	} else if (
	// 		savingsCalculationSettings.PCardLow >=
	// 		savingsCalculationSettings.PCardHigh
	// 	) {
	// 		disableBtn = true;
	// 	} else if (
	// 		savingsCalculationSettings.OpportuneLow >
	// 		savingsCalculationSettings.OpportuneHigh
	// 	) {
	// 		disableBtn = true;
	// 	}

	// 	return disableBtn;
	// };

	const handleSettingsChange = (name, value) => {
		setSavingsCalculationSettings({
			...savingsCalculationSettings,
			[name]:
				value && Number(value) === 0
					? 1
					: value && Number(value) > 100
						? 100
						: value,
		});
	};

	return (
		<ToggleSidebar
			key={3}
			id={3}
			name={'capital_settings'}
			heading={'Savings Calculation Settings'}
			show={closeSettings}
			handleClose={() => setCloseSettings(state => !state)}
			width={'40%'}
			toRight={true}
		>
			{isSaving && renderSavingBlock()}

			<SettingsContainer>
				<CategoryInsightRow>
					<CategoryInsightLabel style={{ fontWeight: 'bold' }}>
						{'Filter Name'}
					</CategoryInsightLabel>
					<CategoryInsightValue>
						<CategoryInsightLabel
							style={{ fontWeight: 'bold' }}
						>{`Low`}</CategoryInsightLabel>
						<CategoryInsightLabel
							style={{ fontWeight: 'bold' }}
						>{`High`}</CategoryInsightLabel>
					</CategoryInsightValue>
				</CategoryInsightRow>
				<CategoryInsightRow>
					<CategoryInsightLabel
					>{`W/C REDUCTION by REDUCING PAYMENT RUN`}</CategoryInsightLabel>
					<CategoryInsightValue>
						<ApInput
							type="number"
							name="DelayLow"
							placeholder="No.of days"
							value={savingsCalculationSettings.DelayLow}
							onChange={v => {
								handleSettingsChange('DelayLow', v);
							}}
						/>
						<SettingsHighDiv>
							<ApInput
								type="number"
								name="DelayHigh"
								placeholder="No.of days"
								value={savingsCalculationSettings.DelayHigh}
								onChange={v => {
									handleSettingsChange('DelayHigh', v);
								}}
							/>
						</SettingsHighDiv>
					</CategoryInsightValue>
				</CategoryInsightRow>
				<CategoryInsightRow>
					<CategoryInsightLabel
					>{`W/C REDUCTION by REDUCING EARLY PAYMENT`}</CategoryInsightLabel>
					<CategoryInsightValue>
						<ApInput
							type="number"
							name="EarlyLow"
							placeholder="Success%"
							value={savingsCalculationSettings.EarlyLow}
							onChange={v => {
								handleSettingsChange('EarlyLow', v);
							}}
						/>
						<SettingsHighDiv>
							<ApInput
								type="number"
								name="EarlyHigh"
								placeholder="Success%"
								value={savingsCalculationSettings.EarlyHigh}
								onChange={v => {
									handleSettingsChange('EarlyHigh', v);
								}}
							/>
						</SettingsHighDiv>
					</CategoryInsightValue>
				</CategoryInsightRow>
				<CategoryInsightRow>
					<CategoryInsightLabel
					>{`W/C REDUCTION by NEGOTIATITE (EXTEND) PAY TERMS`}</CategoryInsightLabel>
					<CategoryInsightValue>
						<ApInput
							type="number"
							name="WCLow"
							placeholder="Success%"
							value={savingsCalculationSettings.WCLow}
							onChange={v => {
								handleSettingsChange('WCLow', v);
							}}
						/>
						<SettingsHighDiv>
							<ApInput
								type="number"
								name="WCHigh"
								placeholder="Success%"
								value={savingsCalculationSettings.WCHigh}
								onChange={v => {
									handleSettingsChange('WCHigh', v);
								}}
							/>
						</SettingsHighDiv>
					</CategoryInsightValue>
				</CategoryInsightRow>
				<CategoryInsightRow>
					<CategoryInsightLabel
					>{`W/C REDUCTION by NEGOTIATITE (HARMONIZE) PAY TERMS`}</CategoryInsightLabel>
					<CategoryInsightValue>
						<ApInput
							type="number"
							name="OpportuneLow"
							placeholder="Success%"
							value={savingsCalculationSettings.OpportuneLow}
							onChange={v => {
								handleSettingsChange('OpportuneLow', v);
							}}
						/>
						<SettingsHighDiv>
							<ApInput
								type="number"
								name="OpportuneHigh"
								placeholder="Success%"
								value={savingsCalculationSettings.OpportuneHigh}
								onChange={v => {
									handleSettingsChange('OpportuneHigh', v);
								}}
							/>
						</SettingsHighDiv>
					</CategoryInsightValue>
				</CategoryInsightRow>
				<CategoryInsightRow>
					<CategoryInsightLabel
					>{`W/C REDUCTION by moving to PCard`}</CategoryInsightLabel>
					<CategoryInsightValue>
						<ApInput
							type="number"
							name="PCardLow"
							placeholder="Success%"
							value={savingsCalculationSettings.PCardLow}
							onChange={v => {
								handleSettingsChange('PCardLow', v);
							}}
						/>
						<SettingsHighDiv>
							<ApInput
								type="number"
								name="PCardHigh"
								placeholder="Success%"
								value={savingsCalculationSettings.PCardHigh}
								onChange={v => {
									handleSettingsChange('PCardHigh', v);
								}}
							/>
						</SettingsHighDiv>
					</CategoryInsightValue>
				</CategoryInsightRow>

				<CategoryInsightRow>
					<CategoryInsightLabel>{`WACC`}</CategoryInsightLabel>
					<CategoryInsightValue>
						<div style={{ width: '100%' }}>
							<ApInput
								type="number"
								name="WACC"
								value={savingsCalculationSettings.WACC}
								onChange={v => {
									handleSettingsChange('WACC', v);
								}}
							/>
						</div>
					</CategoryInsightValue>
				</CategoryInsightRow>
				<ApButtonSecondary
					onClick={() => {
						saveSavingCalculationFilters(setCloseSettings);
					}}
					disabled={
						!savingsCalculationSettings.DelayLow ||
						!savingsCalculationSettings.DelayHigh ||
						!savingsCalculationSettings.EarlyLow ||
						!savingsCalculationSettings.EarlyHigh ||
						!savingsCalculationSettings.WCLow ||
						!savingsCalculationSettings.WCHigh ||
						!savingsCalculationSettings.OpportuneLow ||
						!savingsCalculationSettings.OpportuneHigh ||
						!savingsCalculationSettings.PCardLow ||
						!savingsCalculationSettings.PCardHigh ||
						!savingsCalculationSettings.WACC
					}
				>
					Save
				</ApButtonSecondary>
			</SettingsContainer>
		</ToggleSidebar>
	);
}

export default SavingCalculationSettings;
